import { differenceInDays, format } from 'date-fns';
import { upperOnlyFirst } from '../../formatters';
import analytics from './analytics';
export var labelsConstants = {
  AVAILABLE_HOTEL: 'available',
  UNAVAILABLE_HOTEL: 'unavailable',
  SOLD_OUT_CONSTANT: 'sold out',
  LAST_FEW_ROOMS_CONSTANT: 'last few rooms',
  OPEN_SOON_CONSTANT: 'open soon',
  NO_LABEL_CONSTANT: 'no label',
  UNCHECKED_HOTEL: 'not checked',
  PREMIER_PLUS_LABEL: 'Premier Plus',
  PREMIER_PLUS_FACILITY_CODE: 'PRR',
  MLOS_LABEL: 'MLOS'
};
var updateSearchResultsAnalytics = _ref => {
  var _multiSearchParams$ro, _format, _format2, _multiSearchParams$ro2;
  var isNewSearch = _ref.isNewSearch,
    multiSearchParams = _ref.multiSearchParams,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    viewType = _ref.viewType,
    searchResults = _ref.searchResults,
    searchResultsDisplayed = _ref.searchResultsDisplayed,
    addedResults = _ref.addedResults,
    promotionBannerData = _ref.promotionBannerData;
  var LIST_VIEW = 'list view';
  var MAPPED_ROOM_TYPES = {
    DB: 'Double room',
    SB: 'Single room',
    FAM: 'Family room',
    TWIN: 'Twin room',
    DIS: 'Accessible room'
  };
  var searchDataReduce = multiSearchParams === null || multiSearchParams === void 0 || (_multiSearchParams$ro = multiSearchParams.rooms) === null || _multiSearchParams$ro === void 0 ? void 0 : _multiSearchParams$ro.reduce((acc, current) => {
    return {
      numberOfAdults: (acc === null || acc === void 0 ? void 0 : acc.numberOfAdults) + current.adultsNumber,
      numberOfChildren: (acc === null || acc === void 0 ? void 0 : acc.numberOfChildren) + current.childrenNumber
    };
  }, {
    numberOfAdults: 0,
    numberOfChildren: 0
  });
  var searchWeekdayFrom = startDate && ((_format = format(startDate, 'eee')) === null || _format === void 0 ? void 0 : _format.toLowerCase());
  var searchWeekdayTo = endDate && ((_format2 = format(endDate, 'eee')) === null || _format2 === void 0 ? void 0 : _format2.toLowerCase());
  var rdata = searchResultsDisplayed.map(hotel => {
    var _hotel$hotelAvailabil, _hotel$hotelAvailabil2;
    return btoa(String((_hotel$hotelAvailabil = hotel === null || hotel === void 0 || (_hotel$hotelAvailabil2 = hotel.hotelAvailability) === null || _hotel$hotelAvailabil2 === void 0 ? void 0 : _hotel$hotelAvailabil2.numberOfRoomsAvailable) !== null && _hotel$hotelAvailabil !== void 0 ? _hotel$hotelAvailabil : 0).split('').reverse().join('')).replaceAll('=', '');
  });
  var urlPromo = multiSearchParams === null || multiSearchParams === void 0 ? void 0 : multiSearchParams.promoId;
  var bannerPromo = promotionBannerData === null || promotionBannerData === void 0 ? void 0 : promotionBannerData.promotionCode;
  var bannerTitle = promotionBannerData === null || promotionBannerData === void 0 ? void 0 : promotionBannerData.promoBannerTitle;
  var PromotionType = promotionBannerData === null || promotionBannerData === void 0 ? void 0 : promotionBannerData.promoKind;
  var PromotionTitle;
  if (bannerTitle) {
    var start = bannerTitle.indexOf('<b>');
    var end = bannerTitle.indexOf('</b>', start + 3);
    if (start !== -1 && end !== -1) {
      PromotionTitle = bannerTitle.slice(start + 3, end);
    }
  }
  var PromotionCode = urlPromo ? urlPromo === bannerPromo ? urlPromo : '' : bannerPromo !== null && bannerPromo !== void 0 ? bannerPromo : '';
  analytics.update({
    analyticsDataSearchResult: {
      newSearch: isNewSearch,
      addedResults: addedResults !== null && addedResults !== void 0 ? addedResults : searchResultsDisplayed.length,
      searchCheckInDate: startDate && format(startDate, 'dd/MM/yyyy'),
      searchCheckOutDate: endDate && format(endDate, 'dd/MM/yyyy'),
      searchDaysToCheckIn: startDate && differenceInDays(new Date(startDate), new Date()),
      searchFilter: multiSearchParams.filters,
      searchNumberOfAdults: searchDataReduce.numberOfAdults,
      searchNumberOfChildren: searchDataReduce.numberOfChildren,
      searchNumberOfGuests: searchDataReduce.numberOfAdults + searchDataReduce.numberOfChildren,
      searchNumberOfNights: multiSearchParams.numberOfNights,
      searchNumberOfRooms: multiSearchParams === null || multiSearchParams === void 0 || (_multiSearchParams$ro2 = multiSearchParams.rooms) === null || _multiSearchParams$ro2 === void 0 ? void 0 : _multiSearchParams$ro2.length,
      searchResults,
      searchResultsDisplayed: viewType === LIST_VIEW ? getSearchResults(searchResultsDisplayed, labelsConstants, startDate) : [],
      searchRoomType: multiSearchParams === null || multiSearchParams === void 0 ? void 0 : multiSearchParams.rooms.map(room => {
        var _room$type;
        return MAPPED_ROOM_TYPES[(_room$type = room.type) !== null && _room$type !== void 0 ? _room$type : ''];
      }).join(':'),
      searchSort: multiSearchParams.sort.toLowerCase(),
      searchTerm: multiSearchParams.location.toLowerCase(),
      searchType: viewType,
      searchWeekdayFrom,
      searchWeekdayFromTo: "".concat(searchWeekdayFrom, "-").concat(searchWeekdayTo),
      searchWeekdayTo
    },
    promo: {
      promoName: PromotionTitle,
      promoCode: PromotionCode,
      eligibility: Boolean(PromotionCode),
      bannerType: PromotionType
    }
  });
  analytics.updateEncodedAnalytics(rdata);
};
export function getSearchResults(searchResultsDisplayed, labelsConstants, startDate) {
  var AVAILABLE_HOTEL = labelsConstants.AVAILABLE_HOTEL,
    UNAVAILABLE_HOTEL = labelsConstants.UNAVAILABLE_HOTEL;
  var hotelInformation = searchResultsDisplayed.map(hotel => {
    var _hotel$hotelAvailabil3, _hotel$hotelAvailabil4, _hotel$hotelAvailabil5, _hotel$hotelAvailabil6, _hotel$hotelAvailabil7, _hotel$hotelInformati, _hotel$hotelInformati2, _hotel$hotelAvailabil8, _hotel$hotelAvailabil9, _hotel$hotelAvailabil0, _hotel$hotelAvailabil1;
    return {
      hotelResultPosition: searchResultsDisplayed.indexOf(hotel) + 1,
      hotelAvailability: hotel !== null && hotel !== void 0 && (_hotel$hotelAvailabil3 = hotel.hotelAvailability) !== null && _hotel$hotelAvailabil3 !== void 0 && _hotel$hotelAvailabil3.available ? AVAILABLE_HOTEL : UNAVAILABLE_HOTEL,
      hotelCode: hotel.hotelId.toLowerCase(),
      bookingSystem: upperOnlyFirst((_hotel$hotelAvailabil4 = hotel === null || hotel === void 0 || (_hotel$hotelAvailabil5 = hotel.hotelAvailability) === null || _hotel$hotelAvailabil5 === void 0 ? void 0 : _hotel$hotelAvailabil5.pmsSource) !== null && _hotel$hotelAvailabil4 !== void 0 ? _hotel$hotelAvailabil4 : ''),
      hotelDistance: (_hotel$hotelAvailabil6 = hotel === null || hotel === void 0 || (_hotel$hotelAvailabil7 = hotel.hotelAvailability) === null || _hotel$hotelAvailabil7 === void 0 ? void 0 : _hotel$hotelAvailabil7.distance) !== null && _hotel$hotelAvailabil6 !== void 0 ? _hotel$hotelAvailabil6 : 0,
      hotelFacilityIcons: ((_hotel$hotelInformati = hotel === null || hotel === void 0 || (_hotel$hotelInformati2 = hotel.hotelInformation) === null || _hotel$hotelInformati2 === void 0 ? void 0 : _hotel$hotelInformati2.hotelFacilities) !== null && _hotel$hotelInformati !== void 0 ? _hotel$hotelInformati : []).map(facility => facility.icon),
      hotelLabel: getHotelLabel(hotel, labelsConstants, startDate),
      hotelRates: [{
        cellCode: (_hotel$hotelAvailabil8 = hotel === null || hotel === void 0 || (_hotel$hotelAvailabil9 = hotel.hotelAvailability) === null || _hotel$hotelAvailabil9 === void 0 ? void 0 : _hotel$hotelAvailabil9.cellCode) !== null && _hotel$hotelAvailabil8 !== void 0 ? _hotel$hotelAvailabil8 : '',
        currencyCode: "".concat(hotel === null || hotel === void 0 || (_hotel$hotelAvailabil0 = hotel.hotelAvailability) === null || _hotel$hotelAvailabil0 === void 0 || (_hotel$hotelAvailabil0 = _hotel$hotelAvailabil0.lowestRoomRate) === null || _hotel$hotelAvailabil0 === void 0 ? void 0 : _hotel$hotelAvailabil0.currencyCode),
        description: '',
        lettingType: '',
        price: "".concat(hotel === null || hotel === void 0 || (_hotel$hotelAvailabil1 = hotel.hotelAvailability) === null || _hotel$hotelAvailabil1 === void 0 || (_hotel$hotelAvailabil1 = _hotel$hotelAvailabil1.lowestRoomRate) === null || _hotel$hotelAvailabil1 === void 0 ? void 0 : _hotel$hotelAvailabil1.netTotal.toFixed(2)),
        rateCode: '',
        text: ''
      }]
    };
  });
  return hotelInformation;
}
export function getHotelLabel(hotel, labelsConstants, startDate) {
  var _hotel$hotelAvailabil10, _hotel$hotelInformati3, _hotel$hotelAvailabil11, _hotel$hotelAvailabil12, _hotel$hotelInformati4, _hotel$hotelInformati5, _hotel$hotelInformati6, _hotel$hotelInformati7;
  var LAST_FEW_ROOMS_CONSTANT = labelsConstants.LAST_FEW_ROOMS_CONSTANT,
    OPEN_SOON_CONSTANT = labelsConstants.OPEN_SOON_CONSTANT,
    NO_LABEL_CONSTANT = labelsConstants.NO_LABEL_CONSTANT,
    PREMIER_PLUS_LABEL = labelsConstants.PREMIER_PLUS_LABEL,
    PREMIER_PLUS_FACILITY_CODE = labelsConstants.PREMIER_PLUS_FACILITY_CODE,
    MLOS_LABEL = labelsConstants.MLOS_LABEL;
  var _ref2 = (_hotel$hotelAvailabil10 = hotel === null || hotel === void 0 ? void 0 : hotel.hotelAvailability) !== null && _hotel$hotelAvailabil10 !== void 0 ? _hotel$hotelAvailabil10 : {},
    limitedAvailability = _ref2.limitedAvailability;
  var premierPlusBadge = hotel === null || hotel === void 0 || (_hotel$hotelInformati3 = hotel.hotelInformation) === null || _hotel$hotelInformati3 === void 0 || (_hotel$hotelInformati3 = _hotel$hotelInformati3.hotelFacilities) === null || _hotel$hotelInformati3 === void 0 ? void 0 : _hotel$hotelInformati3.find(facility => facility.code === PREMIER_PLUS_FACILITY_CODE);
  var hasMlosRestriction = (_hotel$hotelAvailabil11 = hotel === null || hotel === void 0 || (_hotel$hotelAvailabil12 = hotel.hotelAvailability) === null || _hotel$hotelAvailabil12 === void 0 ? void 0 : _hotel$hotelAvailabil12.hasMlosRestriction) !== null && _hotel$hotelAvailabil11 !== void 0 ? _hotel$hotelAvailabil11 : false;
  var messagingFlag = hotel === null || hotel === void 0 || (_hotel$hotelInformati4 = hotel.hotelInformation) === null || _hotel$hotelInformati4 === void 0 || (_hotel$hotelInformati4 = _hotel$hotelInformati4.messagingFlag) === null || _hotel$hotelInformati4 === void 0 ? void 0 : _hotel$hotelInformati4.text;
  var labels = [];
  if (messagingFlag && messagingFlag !== 'hub') {
    labels.push(messagingFlag);
  }
  if (hasMlosRestriction) {
    labels.push(MLOS_LABEL);
  }
  if (premierPlusBadge) {
    labels.push(PREMIER_PLUS_LABEL);
  }
  if (limitedAvailability === true) {
    labels.push(LAST_FEW_ROOMS_CONSTANT);
  }
  if ((hotel === null || hotel === void 0 || (_hotel$hotelInformati5 = hotel.hotelInformation) === null || _hotel$hotelInformati5 === void 0 ? void 0 : _hotel$hotelInformati5.hotelOpeningDate) !== '' && startDate && differenceInDays(new Date((_hotel$hotelInformati6 = hotel === null || hotel === void 0 || (_hotel$hotelInformati7 = hotel.hotelInformation) === null || _hotel$hotelInformati7 === void 0 ? void 0 : _hotel$hotelInformati7.hotelOpeningDate) !== null && _hotel$hotelInformati6 !== void 0 ? _hotel$hotelInformati6 : ''), startDate) > 0) {
    labels.push(OPEN_SOON_CONSTANT);
  }
  if (labels.length === 0) {
    labels.push(NO_LABEL_CONSTANT);
  }
  return labels;
}
export default updateSearchResultsAnalytics;